import { BankingAdoptionTaskStatus } from '../types/BankingAdoption';
import useGetBankingAdoption from './useGetBankingAdoption';

const useGetDirectDepositAdoption = () => {
    const { data: bankingAdoption, isLoading: isLoadingBankingAdoption } =
        useGetBankingAdoption();

    const isDirectDepositMarkedAsComplete =
        bankingAdoption?.directDepositStatus ===
        BankingAdoptionTaskStatus.COMPLETE;

    return {
        isDirectDepositAdoptionComplete: isDirectDepositMarkedAsComplete,
        isLoadingDirectDepositAdoption: isLoadingBankingAdoption,
    };
};

export default useGetDirectDepositAdoption;
